export const NotFoundPage = () => {
  return <h1>Not found</h1>;
};
